import { store } from "@/plugins/store";
import router from "@/plugins/router";
import api from "./shelves/api";
import Vue from "vue";
import { Org } from "@/types/api-schema";
import { deserializeError } from "serialize-error";
import { redToast } from "@/components/comflonents/buefyActions";

export default {
  async createSandbox(showLoadingPage = true): Promise<void> {
    try {
      if (showLoadingPage) {
        store.commit("setIsLoading", true);
        router.push("/loading");
      }

      const sandbox = await api.post("users/me/sandbox", {});
      const orgs = await api.get("users/me/orgs");

      store.commit("setOrgs", orgs);
      store.commit("setActiveOrgById", sandbox.orgId);

      router.push({
        name: "legosHQRoute",
        params: { orgSlug: store.getters.idToSlug(sandbox.orgId) },
      });
    } catch {
      alert("error saving to database");
    }
  },
  async createOrg(name: string): Promise<Org> {
    const newOrg = await api.post("users/me/orgs", {
      orgName: name,
    });
    const orgs = await api.get("users/me/orgs");

    store.commit("setOrgs", orgs);
    store.commit("setActiveOrgById", newOrg.orgId);
    return newOrg;
  },
  async handleExceptionCausingLogout(that: Vue) {
    const exceptionCausingLogout = localStorage.getItem(
      "exceptionCausingLogout"
    );
    if (!exceptionCausingLogout) {
      return;
    }
    console.log("exceptionCausingLogout!");
    const e = deserializeError(JSON.parse(exceptionCausingLogout).e);
    const bugTitle =
      JSON.parse(exceptionCausingLogout)?.bugTitle ?? "Unspecified Error";
    const toast =
      JSON.parse(exceptionCausingLogout)?.toast ?? `Login Error - ${bugTitle}`;
    console.error(e);

    redToast(that, toast, 8000);

    localStorage.removeItem("exceptionCausingLogout");
  },
};
